var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plate",class:_vm.$bus.ComPool.status ? 'disabled': '',on:{"click":function($event){return _vm.$bus.addGA('select_plate', 'click')}}},_vm._l((_vm.$bus.actInfo.discounts),function(item,index){return _c('Item',{key:item,attrs:{"index":index}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52136c34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plate/index.vue
// module id = null
// module chunks = 